import React from 'react'
import { Spin } from 'antd'

import { ILoadingComponent } from './types'

export default ({ spin }: ILoadingComponent) => <Spin spinning={spin} />
